const btn = {
  label: 'Ver Mais Equipamentos',
  Typography: 'Nenhum equipamento encontrado para este local'
};

export default btn;
